import classNames from 'classnames';
import React, { useMemo } from 'react';

import Spinner from 'click-controls/controls/spinner';

export interface IProps {
  className?: string;
  isLoading?: boolean;
  isSaving?: boolean;
  spinnerText?: string;
}

const DialogChildren: React.FC<React.PropsWithChildren<IProps>> = ({
  children,
  className: pClassName,
  isLoading,
  isSaving,
  spinnerText
}) => {
  const message = useMemo(() => {
    if (!!spinnerText) return spinnerText;
    return `${isSaving ? 'Saving' : 'Loading'} data...`;
  }, [isSaving]);

  const bodyClass = React.useMemo(() => {
    return classNames('py-2 shrink overflow-y-visible', pClassName); //ideally want this overflow auto but dropdowns don't go on top then
  }, [pClassName]);

  const content = isLoading || isSaving ? <Spinner message={message} /> : children;
  return <div className={bodyClass}>{content}</div>;
};

DialogChildren.defaultProps = {
  isLoading: false,
  isSaving: false
};

export default DialogChildren;
